export interface DeleteReserveGroupRequest {
  id: number
}

export function DeleteReserveGroupRequestToJSON(
  value: DeleteReserveGroupRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
